export enum PaymentOptionType {
  Default = 'Default',
  Minimum = 'Minimum',
  RegularPayment = 'RegularPayment',
  BalancePayoff = 'BalancePayoff',
  PrincipalOnly = 'PrincipalOnly',
  LastStatement = 'LastStatement',
  LoanOnDueDate = 'LoanOnDueDate',
}
